export default {
  GENERAL: 'general',
  NOTIFICATIONS: 'notifications',
  LINKEDEMAILS: 'linkedEmails',
  ADDRESSES: 'addresses',
  PAYMENTMETHOD: 'paymentMethod'
}